import React, { useEffect } from "react"
import { Info } from "components/SvgIcons/icons/info"
import { Price } from "components/Price"
import type { ProductPricingType } from "@shared/graphql.types"
import { useSegment } from "tracking/hooks/useSegment"
import { useInView } from "react-intersection-observer"
import {
  bannerPrice,
  infoIcon,
  typicalPriceBannerWrapper,
} from "./TraditionalRetailBanner.css"
import { TraditionalRetailModal } from "./TraditionalRetailModal"

export type Props = { pricing: ProductPricingType }

export const TraditionalRetailBanner: React.FC<Props> = ({ pricing }) => {
  const { typical } = pricing
  const [showPopup, setShowPopup] = React.useState(false)

  const { track } = useSegment()

  const displayPopup = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "avg_typical_retail_price",
        module_content_details: "see_more_info",
        location_type: "avg_typical_retail_price",
      },
    })
    setShowPopup(true)
  }

  const clickHandler = () => {
    displayPopup()
  }
  const keyboardHandler = (evt) => {
    if (evt.key === "Enter") {
      displayPopup()
    }
  }

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  })

  useEffect(() => {
    if (inView) {
      track({
        event: "Page Element Viewed",
        properties: {
          module_content: "avg_typical_retail_price_pop_up",
          location_type: "avg_typical_retail_price_pop_up",
        },
      })
    }
  }, [inView, track])

  return (
    <>
      <div
        className={typicalPriceBannerWrapper}
        onClick={clickHandler}
        onKeyUp={keyboardHandler}
        role="button"
        tabIndex={-1}
        ref={ref}
      >
        <p style={{ position: "relative" }}>
          Traditional Retail Price
          <Info className={infoIcon} />
        </p>
        <p className={bannerPrice}>
          <Price price={typical} />
        </p>
      </div>
      {showPopup && (
        <TraditionalRetailModal
          isOpen={showPopup}
          onDismiss={() => {
            setShowPopup(false)
          }}
        />
      )}
    </>
  )
}
